import { SummarizerConfig } from '../../types/summarizer';

export const audioFileSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'audio-file-summarizer',
  title: 'Audio File Summarizer',
  description: 'Upload and transcribe audio files with AI-powered summarization',
  version: '1.0.0',

  // Categorization
  category: 'audio',
  tags: ['audio', 'mp3', 'wav', 'recording', 'transcription'],

  // Input configuration
  inputs: {
    file: {
      enabled: true,
      acceptedTypes: ['.mp3', '.wav', '.m4a', '.aac', '.ogg','.webm'],
      maxSize: 200 * 1024 * 1024, // 200MB in bytes
      placeholder: 'Upload your audio file',
      multiple: false,
      helpText: 'Upload audio files up to 200MB. Supports MP3, WAV, M4A, and other common formats.',
      showHelpText: true,
    },
    url: {
      enabled: true,
      placeholder: 'Or enter direct audio URL',
      // validation: /\.(mp3|wav|m4a|aac|ogg|flac|wma)$/i,
      examples: ['https://example.com/audio.mp3', 'https://cdn.site.com/recording.wav'],
      showExamples: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'audio',
    timeout: 60000, // Longer timeout for audio processing
  },

  // UI customization
  ui: {
    primaryColor: '#9333ea',
    secondaryColor: '#a855f7',
    icon: '🎵',
    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 1000, // 1KB minimum
    maxSize: 209715200, // 200MB in bytes
    allowedDomains: [],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
